import { groupBy } from 'lodash'
import * as Effects from 'redux-saga/effects'
import { all, call, put, select, take } from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import { acceptTemplates } from '../../actions/templates/loadTemplates'
import { fireToastSuccess } from '../../actions/toasts/fireToast'
import i18n from '../../i18n'
import restoreDefaultTemplates from '../../models/Templates/restoreDefaultTemplates'
import { TemplatesActions } from '../../reducers/templates/actionNames'
import { getTemplates } from '../../reducers/templates/selectors/templates'
import fetchActionsName, { ActionNames } from '../../utils/FetchActionsName'

function* restoreDefault(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.SaveTemplate)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(
        callFetch(
          actionNames.input,
          actionNames.output,
          restoreDefaultTemplates,
        ),
      ),
    ])

    let template = yield call(service, action.lang)

    let temp = yield select(getTemplates)

    template = template.find(t => t.typeTitle === action.typeTitle)

    temp = temp.map(t =>
      t.typeTitle === action.typeTitle
        ? { ...template, id: t.id, idUser: t.idUser }
        : t,
    )

    yield Effects.put(acceptTemplates(temp, groupBy(temp, 'language')))

    yield Effects.put(
      fireToastSuccess(
        i18n.t('BBO_992_templates_restored'),
        5000,
        'Main',
        'restoredDefault',
      ),
    )
  } catch (e) {
    console.error(e)
  }
}

export default function* () {
  yield Effects.takeLatest(TemplatesActions.RestoreDefault, restoreDefault)
}
